import { Field, Portal,Flex, Button, Text,Drawer,CloseButton } from "@chakra-ui/react"
import { useNavigate } from "react-router";
import { RxExit } from "react-icons/rx";
import { useSelector } from "react-redux";
import { signInWithRedirect, signOut } from "@aws-amplify/auth";

const PTCMenu = ({menuOpen,setMenuOpen})=>{
    const navigate = useNavigate();
    const user = useSelector(u=>u.userContext.user);
    const handleSignOut = async() =>{
      await signOut(); 
      await signInWithRedirect();
    }
    return(
        <Drawer.Root open={menuOpen} size={'xs'} placement="start" onOpenChange={(e) => setMenuOpen(e.open)}>
            <Portal>
              <Drawer.Backdrop />
              <Drawer.Positioner>
                <Drawer.Content>
                  <Drawer.Header>
                    <Drawer.Title>Menu</Drawer.Title>
                  </Drawer.Header>
                  <Drawer.Body>
                  <Flex direction={'column'} height={"100%"} justifyContent={'space-between'}>
                    <Flex direction={"column"} gap={"10px"}   padding={'10px'}>
                      {user ? <Text>{`Hi, ${user.name}`}</Text> : null}
                      
                      {user.company === 'ptc' ? (<Button onClick={()=>{navigate('/home/tagihan');setMenuOpen(false)}}>Tagihan</Button>) : null}
                      {user.company === 'ptc' ? (<Button onClick={()=>{navigate('/home/unit');setMenuOpen(false)}}>Unit</Button>):null}

                    </Flex>

                    <Flex flexDirection={'column'}>
                      <Button variant="outline" onClick={()=>{handleSignOut()}}> <RxExit/>Keluar</Button>  
                    </Flex>
                  </Flex>

                  </Drawer.Body>
                  <Drawer.CloseTrigger asChild>
                    <CloseButton size="sm" />
                  </Drawer.CloseTrigger>
                </Drawer.Content>
              </Drawer.Positioner>
            </Portal>
          </Drawer.Root>
    )
}

export default PTCMenu;